export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      2967.8004535147393,
    ],
    button_spin: [
      4000,
      793.8321995464852,
    ],
    end_free_spin: [
      6000,
      1838.7301587301588,
    ],
    free_bet_big_win: [
      9000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      12000,
      2213.151927437641,
    ],
    free_bet_total_win: [
      16000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      18000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      21000,
      26791.473922902496,
    ],
    free_spin_music: [
      49000,
      29335.510204081627,
    ],
    free_spin_popup: [
      80000,
      4683.174603174606,
    ],
    free_spin_start: [
      86000,
      4509.024943310664,
    ],
    inside_buttons: [
      92000,
      338.14058956916426,
    ],
    main_ambient: [
      94000,
      92144.03628117913,
    ],
    main_music: [
      188000,
      179390.11337868482,
    ],
    mega_win: [
      369000,
      3736.9614512471685,
    ],
    outside_buttons: [
      374000,
      245.26077097505095,
    ],
    reel_spin: [
      376000,
      1994.0136054421487,
    ],
    reel_stop_01: [
      379000,
      175.60090702949083,
    ],
    reel_stop_02: [
      381000,
      175.60090702949083,
    ],
    reel_stop_03: [
      383000,
      198.82086167802981,
    ],
    reel_stop_04: [
      385000,
      175.60090702949083,
    ],
    reel_stop_05: [
      387000,
      175.60090702949083,
    ],
    regular_win: [
      389000,
      2143.49206349209,
    ],
    scatter_chance: [
      393000,
      4729.614512471642,
    ],
    tap_to_play: [
      399000,
      15550.113378684784,
    ],
    ultra_win: [
      416000,
      3914.0136054421646,
    ],
  },
}
